// src/utils/rotas.js
//
// Para onde vai um clique num imóvel.
//
// A plataforma tem três moldes: a área do usuário (/dashboard), a do admin
// (/admin) e as páginas soltas de página cheia. Cada molde tem sua própria
// sidebar, e mandar alguém de dentro de um deles para uma rota solta faz a
// navegação sumir no meio do caminho — a pessoa perde o menu e acha que saiu
// do sistema.
//
// Regra única: a rota de destino acompanha a área onde a pessoa já está.
// Se algum dia surgir uma quarta área, muda aqui e vale para todo mundo.

const AREAS = ['/dashboard', '/admin'];

function areaAtual(pathname = '') {
  return AREAS.find((a) => String(pathname).startsWith(a)) || null;
}

// Destino de um imóvel. A análise (calculadora) é o destino certo: é ela que
// mostra os números, e é o passo que queremos que a pessoa dê.
export function rotaAnalise(pathname, id) {
  const area = areaAtual(pathname);
  return area ? `${area}/analise/${id}` : `/calculadora/${id}`;
}

// Ficha do imóvel, quando o que se quer é o detalhe e não a análise.
export function rotaImovel(pathname, id) {
  const area = areaAtual(pathname);
  return area ? `${area}/analise/${id}` : `/leilao/${id}`;
}

// Tela de busca com filtros, na área onde a pessoa já está. Fora das áreas vai
// para a do usuário — é para lá que /leiloes já redireciona.
export function rotaBusca(pathname) {
  const area = areaAtual(pathname);
  return `${area || '/dashboard'}/buscar`;
}

export { areaAtual };

export function rotaMapa(pathname) { return `${areaAtual(pathname) || '/dashboard'}/mapa`; }
